import { TextField, ThemeProvider, createTheme } from "@mui/material";
import { Fragment, useMemo, useRef } from "react";
import {
  useAsyncDebounce,
  useBlockLayout,
  useColumnOrder,
  useFilters,
  useGlobalFilter,
  usePagination,
  useRowSelect,
  useSortBy,
  useTable,
} from "react-table";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { InputAdornment, Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import { ToastContainer, toast } from "react-toastify";
import FilterTable from "./FilterTable";
import ReactTable from "../blacklist/ReactTable";
// import { common_axios } from "../../..";
import { common_axios } from "../../../App";
import DeleteIcon from "@mui/icons-material/Delete";
import ColumnFilter from "../Reacttable/UserManagement/ReactTableFiles/ColumnFilter";
import Loader from "../../../components/Loader";
import Backdrop from "@mui/material/Backdrop";
import { withRouter } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import FilterListIcon from "@mui/icons-material/FilterList";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import CheckIcon from "@mui/icons-material/Check";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import SettingsBackupRestoreRoundedIcon from "@mui/icons-material/SettingsBackupRestoreRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import Activate from "./Activate";
import Deactivate from "./Deactivate";
import Swal from "sweetalert2";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import Autocomplete from "@mui/material/Autocomplete";
const FilterKeyword = () => {
  //.........useState..................//
  const [data, setData] = useState([]);
  const [disable, setDisable] = useState(true);
  const [editDetails, seteditDetails] = useState();
  const [userState, setUserState] = React.useState([]);
  const [accountidvalue, setAccountIdValue] = useState([]);
  const [hideSkeleton1, setHideSkeleton1] = useState();

  const [TableStatus, setTableStatus] = useState({
    // hideShow: false,
    pageNo: 0,
    pageSize: 10,
  });
  const [data1, setData1] = useState([]);
  const customId1 = "custom-id-yess";
  // ...................................Theme Provider....................................//

  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: { color: "red" },
          // "&$error": {
          //   color: "#db3131",
          // },
        },
      },
    },
  });

  // .....................................Formik............................................//

  const initialValues = {
    keyword: "",
  };

  const validationSchema = yup.object({
    keyword: yup
      .string()
      .min(3, "Please enter atleast 3 characters in keyword")
      .max(90, "No more longer to 90 charcaters")
      .required("Required"),
  });

  const formik = useFormik({
    initialValues: initialValues,

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      FilterPost(values);
    },
  });

  // .........................................Post API.......................................//

  async function FilterPost(values) {
    let userIds = [];
    for (let i = 0; i < userState.length; i++) {
      if (userState[i].userId != "all") {
        userIds[i] = userState[i].userId;
      }
    }

    try {
      setOpen(true);
      const res = await common_axios.post(
        // "http://192.168.167.66:5002/v1/drools-rule/save",

        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/save/keywords`,
        {
          keywordRequest: {
            keyword: values.keyword,
            status: false,
            userId:
              JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_SUPER_ADMIN"
                ? userIds?.length > 0
                  ? userIds
                  : null
                : [JSON.parse(localStorage.getItem("items")).uid],
            // allFlag: false,
            // allFlag: userIds?.length > 0 ? true : false,
            //  allFlag:userIds?.length > 0 ? false : true ,
            allFlag:
              JSON.parse(localStorage.getItem("Sidebaritems")).name ==
              "ROLE_SUPER_ADMIN"
                ? userIds?.length > 0
                  ? false
                  : true
                : false,
            createdBy: localStorage.getItem("usernamedisplayed"),
          },
        }
      );
      if (res.data.statusDescription.statusCode == 200) {
        setOpen(false);
        setUserState([]);
        formik.handleReset();
        // FilterGet();
        // toast.success("Keyword added successfully!!", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text: "Keyword added successfully!!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
        // values.keyword = "";
      } else if (res.data.statusDescription.statusCode == 202) {
        // toast.error("Keyword already exists !!",{
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Keyword already exists !!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });

        setOpen(false);
      } else {
        setOpen(false);
        // toast.error(res.data.statusDescription.statusdescription,{
        //   toastId: customId1,
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: res.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      setOpen(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // .......................................Get API.........................................//
  // console.log("data556", data);
  // ............................................................................................//
  async function AccountId() {
    // alert("hii");
    // console.log("first");
    try {
      setHideSkeleton1(true);
      const result = await common_axios(
        // "http://192.168.167.66:5002/v1/get-rules"
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/v1/drools-rule/get/user/data`
      );
      if (result.data.statusDescription.statusCode == 200) {
        setHideSkeleton1(false);
        let x = [
          {
            userId: "all",
            userName: "All",
          },
        ];
        let temp = [...x, ...result.data.accountId];
        // temp.push({
        //   userId: 0,
        //   userName: "All",
        // });
        setAccountIdValue(temp);
        // setAccountIdValue(result.data.accountId);
      } else {
        setHideSkeleton1(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusdescription,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // setOpen(false);
      setHideSkeleton1(false);
      // toast.error("Please Check Your Network",{
      //   toastId: customId1,
      //   theme: "colored",
      //  });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  // useEffect(() => {
  //   AccountId();
  // }, []);
  // -----------------------------------Filter Table-------------------------------

  const [open, setOpen] = useState(false);
  const [selectedUserDetail, setSelectedUserDetail] = useState(undefined);
  const [selectedUserDetailApprove, setSelectedUserDetailApprove] =
    useState(undefined);
  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const modelButtonReject = useRef(null);
  const modelButtonApprove = useRef(null);
  const modelActDeactApprove = useRef(null);
  const approveUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetailApprove(cell.row.original);
    seteditDetails(cell.row.original.keyword);
    await modelButtonApprove.current.click();
  };
  const [actDeactDetailApprove, setActDeactDetailApprove] = useState(undefined);
  const approveUserActDeact = async (cell) => {
    setActDeactDetailApprove(cell.row.original);
    await modelActDeactApprove.current.click();
  };
  const rejectUserModal = async (cell) => {
    // console.log(cell.row.original);
    await setSelectedUserDetail(cell.row.original);
    await modelButtonReject.current.click();
  };
  const x = 2;
  const columns = useMemo(
    () => [
      {
        Header: "Id",
        accessor: "id", // accessor is the "key" in the data
      },

      {
        Header: "Keyword",
        accessor: "keyword",
      },
      {
        Header: "Created By",
        accessor: "createdBy", // accessor is the "key" in the data
      },

      {
        Header: "Status",
        accessor: "response",
        Cell: (cell) => (
          <div className="">
            <button
              className="btn color_1  "
              type="button"
              id="dropdownMenuButton1"
              aria-expanded="false"
            >
              {/* {console.log("cell111", cell)} */}
              {cell.row.original.response == true ? (
                <>
                  <span class="badge bg-danger activated_1">Deactivated</span>
                </>
              ) : (
                <>
                  <span class="badge bg-success activated_1">Activated</span>
                </>
              )}

              {/* <DeleteIcon /> */}
            </button>
          </div>
        ),

        disableFilters: true,
      },

      {
        Header: "Action",
        accessor: "action",
        Cell: (cell) => (
          <div className="dropdown">
            <button
              className="btn color_1 dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="material-icons opacity-10 size">person</i>
              {/* <DeleteIcon /> */}
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              <li
                onClick={() => {
                  // console.log(cell);
                }}
              >
                <a
                  className="dropdown-item"
                  onClick={() => {
                    rejectUserModal(cell);
                  }}
                >
                  <DeleteIcon />
                  Delete
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    approveUserModal(cell);
                  }}
                >
                  <EditIcon />
                  Edit Details
                </a>
              </li>
              <li>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    approveUserActDeact(cell);
                  }}
                >
                  {/* {console.log("cell-----", cell)} */}
                  {cell.row.original.response == false ? (
                    <>
                      {/* {alert("if")} */}
                      <RemoveCircleOutlineIcon />
                      Deactivate
                    </>
                  ) : (
                    <>
                      {/* {alert("else")} */}
                      <CheckIcon />
                      Activate
                    </>
                  )}

                  {/* <EditIcon />
                  ACtivate */}
                </a>
              </li>
            </ul>
          </div>
        ),

        disableFilters: true,
      },
    ],
    []
  );

  // console.log(Status, "lalalaallalas");

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    page,
    nextPage,
    canNextPage,
    previousPage,
    canPreviousPage,
    pageOptions,
    gotoPage,
    pageCount,
    setPageSize,
    prepareRow,
    state,
    setGlobalFilter,
    selectedFlatRows,
    setColumnOrder,
    allColumns,
    getToggleHideAllColumnsProps,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect
  );

  const { globalFilter, pageIndex, pageSize } = state;
  const [globalSearchValue, setGlobalSearchValue] = useState(globalFilter);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 1000);

  const deletUser = () => {
    // console.log({ selectedFlatRows });
  };

  const changeOrder = () => {
    setColumnOrder(["id", "username", "action", "role", "email"]);
  };

  // --------------------activate get api-------------------------------
  const [activeData, setActiveData] = useState([]);
  const [activePageData, setActivePageData] = useState([]);
  const [deactiveData, setDeactiveData] = useState([]);
  const [deactivePageData, setDeactivePageData] = useState([]);
  async function FilterGet() {
    try {
      setOpen(true);

      const result = await common_axios.post(
        // `http://192.168.167.66:5002/v1/drools-rule/get-rules?pageNo=${pageNumber1}&pageSize=${PageSize1}`
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/get/all/keywords`,
        // {
        //   // status: "DND",
        //   // pageNo: "0",
        //   // pageSize: "10",
        //   droolsReq: {
        //     pageNo: "0",
        //     pageSize: "10",
        //     status: false,
        //   },
        // }

        {
          keywordRequest: {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
            status: true,
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        // setData(result.data.droolsRules.content);
        setActiveData(result.data.keyWordResponse);
        setActivePageData(result.data);
        setOpen(false);
      } else {
        setOpen(false);
        setActiveData([]);
        setActivePageData([]);
        // toast.error(result.data.statusDescription.statusMessage, {
        //   toastId: customId1,
        //   theme: "colored",
        // });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }

  // --------------------------------------------------------------------

  // -----------deactivate get api----------------------------------------
  async function DeactivateGet() {
    try {
      setOpen(true);

      const result = await common_axios.post(
        // `http://192.168.167.66:5002/v1/drools-rule/get-rules?pageNo=${pageNumber1}&pageSize=${PageSize1}`
        `${process.env.REACT_APP_COMMON_API_DNDBLACKLISTWHIELIST}/keywords/v2/get/all/keywords`,
        // {
        //   // status: "DND",
        //   // pageNo: "0",
        //   // pageSize: "10",
        //   droolsReq: {
        //     pageNo: "0",
        //     pageSize: "10",
        //     status: true,
        //   },
        // }
        {
          keywordRequest: {
            pageNo: TableStatus?.pageNo,
            pageSize: TableStatus?.pageSize,
            status: false,
          },
        }
      );
      if (result.data.statusDescription.statusCode == 200) {
        setDeactiveData(result.data.keyWordResponse);
        setDeactivePageData(result.data);
        setOpen(false);
      } else {
        setOpen(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.statusDescription.statusMessage,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } catch (error) {
      // console.log(error);
      setOpen(false);

      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please Check Your Network",
        // footer: '<a href="">Why do I have this issue?</a>'
      });
    }
  }
  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem("Sidebaritems")).name ==
      "ROLE_SUPER_ADMIN"
    ) {
      AccountId();
    }
  }, []);
  // ------------------------------------------------------------------------
  return (
    <>
      <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <div>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={open}
          >
            <Loader />
          </Backdrop>
        </div>
        {/* ......................................................... */}
        <div className="container-fluid">
          {/* <!-- <h6 className="font-weight-bolder mb-4">Add Source Masking Details.</h6> --> */}
          <div className="row">
            <div className="col-xl-12 col-sm-12 mb-xl-0 mb-4">
              <div className="card mb-3 mt-4">
                <div className="card-header p-3 pt-2">
                  <div className="icon icon-lg icon-shape bg-gradient-primary shadow-primary text-center border-radius-xl mt-n4 position-absolute">
                    <i
                      class="material-icons ttl_icon  opacity-10 rule"
                      style={{ fontSize: "unset" }}
                    >
                      {/* filter_list */}
                      <FilterListIcon style={{ fontSize: "28px" }} />
                    </i>
                  </div>
                  <div class="pt-1 marginleft_0">
                    <p class="text-sm mb-0 text-capitalize fw-bold">
                      Spam Manager
                    </p>
                    <p className="text-sm mb-0  text d-inline-block float-end">
                      Field(s) marked with{" "}
                      <span className="text-danger fw-bold">*</span> are
                      mandatory.
                    </p>
                  </div>
                </div>
                <ThemeProvider theme={theme}>
                  <div className="card-body">
                    {/* --------------------------------------------- */}
                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                      <li className="nav-item  list_1" role="presentation">
                        <button
                          className="nav-link active"
                          id="home-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#AccountDetails"
                          type="button"
                          role="tab"
                          aria-controls="AccountDetails"
                          aria-selected="true"
                          onClick={() => {
                            document.getElementById("home-tab2").click();
                          }}
                        >
                          {/* MSISDN */}
                          {/* Mobile Number */}
                          Add Spam Keyword
                        </button>
                      </li>
                      <li className="nav-item  list_1" role="presentation">
                        <button
                          className="nav-link ms-2"
                          id="SenderMasking-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#SenderMasking"
                          type="button"
                          role="tab"
                          aria-controls="SenderMasking"
                          aria-selected="false"
                          // onClick={senderMasking}
                          onClick={FilterGet}
                          // disabled
                        >
                          {/* Choose File */}
                          Existing Spam Keyword List
                        </button>
                      </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active"
                        id="AccountDetails"
                        role="tabpanel"
                        aria-labelledby="AccountDetails-tab"
                      >
                        <div className="card shadow-none border bg_blue mt-5">
                          <span className="badge rounded-pill bg-primary mt-n3 ms-5">
                            Add Spam Keyword
                          </span>
                          <div className="card-body text-lg-start text-center">
                            <form
                              onSubmit={formik.handleSubmit}
                              role="form"
                              className="text-start"
                            >
                              <div className="tab-content" id="myTabContent">
                                <div
                                  className="tab-pane fade show active"
                                  id="AccountDetails"
                                  role="tabpanel"
                                  aria-labelledby="AccountDetails-tab"
                                >
                                  <div className="row mt-4">
                                    <div className="col-md-4 pr-0">
                                      <div className="d-flex align-items-center">
                                        <label
                                          for="exampleInputEmail1"
                                          class="form-label fw-bold m-0 me-2"
                                        >
                                          Keyword:
                                        </label>
                                        <TextField
                                          className="w-100 "
                                          style={{
                                            borderRadius: "4px",
                                          }}
                                          type="text"
                                          label="Enter Keyword"
                                          name="keyword"
                                          variant="outlined"
                                          size="small"
                                          required
                                          InputProps={{
                                            endAdornment: (
                                              <InputAdornment position="end">
                                                <Tooltip
                                                  title="Spam Keyword"
                                                  placement="top"
                                                  arrow
                                                  sx={{ color: "#85CBF2" }}
                                                >
                                                  <InfoIcon />
                                                </Tooltip>
                                              </InputAdornment>
                                            ),
                                          }}
                                          onChange={formik.handleChange}
                                          value={formik.values.keyword}
                                          error={
                                            formik.touched.keyword &&
                                            Boolean(formik.errors.keyword)
                                          }
                                          helperText={
                                            formik.touched.keyword &&
                                            formik.errors.keyword
                                          }
                                        />
                                      </div>
                                    </div>

                                    {JSON.parse(
                                      localStorage.getItem("Sidebaritems")
                                    ).name == "ROLE_SUPER_ADMIN" ? (
                                      <>
                                        {" "}
                                        {hideSkeleton1 == true ? (
                                          <>
                                            <Box sx={{ width: "25%" }}>
                                              <Skeleton />
                                              <Skeleton animation="wave" />
                                              {/* <Skeleton animation={false} /> */}
                                            </Box>
                                          </>
                                        ) : (
                                          <>
                                            <div className="col-md-3">
                                              <Autocomplete
                                                aria-required
                                                // disabled={MenuItemPhoneBook==undefined}
                                                size="small"
                                                fullWidth
                                                value={userState}
                                                onChange={(e, val) => {
                                                  setUserState(val);
                                                }}
                                                multiple
                                                limitTags={2}
                                                id="multiple-limit-tags"
                                                options={accountidvalue}
                                                getOptionDisabled={(option) =>
                                                  userState?.[0]
                                                    ? userState?.[0]
                                                        ?.userName === "All"
                                                      ? option.userName !==
                                                        "All"
                                                      : option.userName ===
                                                        "All"
                                                    : null
                                                }
                                                //       getOptionDisabled={(option) =>
                                                //   option === timeSlots[0] || option === timeSlots[2]
                                                // }
                                                // getOptionDisabled={(option) =>
                                                //         option.userName === 'All'
                                                //       }
                                                getOptionLabel={(option) =>
                                                  option?.userName
                                                }
                                                // defaultValue={mappingArray}
                                                renderInput={(params) => (
                                                  <TextField
                                                    size="small"
                                                    fullWidth
                                                    {...params}
                                                    label="User Name List"
                                                    // required
                                                    // placeholder="User Name List"
                                                  />
                                                )}
                                              />
                                            </div>
                                          </>
                                        )}
                                        <div className="col-md-5 col-lg-4 ">
                                          <button
                                            type="submit"
                                            className="btn green_UP  ms-5 btn_w8"
                                            disabled={
                                              formik?.values?.keyword === "" ||
                                              userState?.length == 0
                                            }
                                          >
                                            Add
                                            {/* <AddRoundedIcon
                                              style={{ fontSize: "19px" }}
                                            /> */}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn resetBtn_UP ms-3 w_btn btn_w8"
                                            onClick={() => {
                                              formik.resetForm();
                                              setUserState([]);
                                            }}
                                          >
                                            Reset
                                            {/* <SettingsBackupRestoreRoundedIcon
                                              style={{ fontSize: "17px" }}
                                            /> */}
                                          </button>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <div className="col-md-3">
                                          <TextField
                                            required
                                            disabled
                                            className="w-100"
                                            label="Name"
                                            // name="name"
                                            variant="outlined"
                                            size="small"
                                            value={localStorage.getItem(
                                              "usernamedisplayed"
                                            )}
                                            type="text"
                                            InputProps={{
                                              endAdornment: (
                                                <InputAdornment position="end">
                                                  <Tooltip
                                                    title="Name"
                                                    placement="top"
                                                    arrow
                                                    sx={{ color: "#85CBF2" }}
                                                  >
                                                    <InfoIcon />
                                                  </Tooltip>
                                                </InputAdornment>
                                              ),
                                            }}
                                          />
                                        </div>
                                        <div className="col-md-5 ">
                                          <button
                                            type="submit"
                                            className="btn green_UP ms-5 btn_w8"
                                            //               disabled={
                                            //   formik?.values?.keyword === "" ||
                                            //   userState?.length == 0
                                            // }
                                          >
                                            Add
                                            {/* <AddRoundedIcon
                                              style={{ fontSize: "19px" }}
                                            /> */}
                                          </button>
                                          <button
                                            type="button"
                                            className="btn resetBtn_UP ms-3 w_btn btn_w8"
                                            onClick={() => {
                                              formik.resetForm();
                                              setUserState([]);
                                            }}
                                          >
                                            Reset
                                            {/* <SettingsBackupRestoreRoundedIcon
                                              style={{ fontSize: "17px" }}
                                            /> */}
                                          </button>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>

                      <div
                        className="tab-pane fade mt-4"
                        id="SenderMasking"
                        role="tabpanel"
                        aria-labelledby="SenderMasking-tab"
                      >
                        {/* ....................................................................... */}

                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                          <li className="nav-item  list_1" role="presentation">
                            <button
                              className="nav-link active"
                              id="home-tab2"
                              data-bs-toggle="tab"
                              data-bs-target="#AccountDetails1"
                              type="button"
                              role="tab"
                              aria-controls="AccountDetails1"
                              aria-selected="true"
                              // onClick={FilterGet}
                              onClick={() => {
                                setTableStatus({
                                  ...TableStatus,
                                  pageNo: 0,
                                  pageSize: 10,
                                });
                                FilterGet();
                              }}
                            >
                              {/* MSISDN */}
                              {/* Mobile Number */}
                              Activate Keyword
                            </button>
                          </li>
                          <li className="nav-item  list_1" role="presentation">
                            <button
                              className="nav-link ms-2"
                              id="SenderMasking-tab1"
                              data-bs-toggle="tab"
                              data-bs-target="#SenderMasking1"
                              type="button"
                              role="tab"
                              aria-controls="SenderMasking1"
                              aria-selected="false"
                              // onClick={DeactivateGet}
                              onClick={() => {
                                setTableStatus({
                                  ...TableStatus,
                                  pageNo: 0,
                                  pageSize: 10,
                                });
                                DeactivateGet();
                              }}
                              // disabled
                            >
                              {/* Choose File */}
                              Deactivate Keyword
                            </button>
                          </li>
                        </ul>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="AccountDetails1"
                            role="tabpanel"
                            aria-labelledby="AccountDetails-tab1"
                          >
                            <Activate
                              activeData={activeData}
                              activePageData={activePageData}
                              pageno={TableStatus?.pageNo}
                              pagesize={TableStatus?.pageSize}
                            />
                          </div>
                          <div
                            className="tab-pane fade"
                            id="SenderMasking1"
                            role="tabpanel"
                            aria-labelledby="SenderMasking-tab1"
                          >
                            <Deactivate
                              deactiveData={deactiveData}
                              deactivePageData={deactivePageData}
                              pageno={TableStatus?.pageNo}
                              pagesize={TableStatus?.pageSize}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ThemeProvider>
              </div>
            </div>
          </div>
        </div>
      </main>
      {/* -------------------------------------------------------------------------- */}
    </>
  );
};

export default withRouter(FilterKeyword);
